import React, { useEffect } from 'react';
import { Layout } from 'antd';
import { PageContainer } from '@ant-design/pro-components';
import { AdminFinances, ManagerFinances, ProductionFinances } from './components';
import { getDepartmentType, isSalesDepartment } from './utils/departmentDetector';
import { changePageTitle } from '../../utils/title';

/**
 * Главная страница раздела "Мои финансы"
 * 
 * Определяет тип пользователя и отображает соответствующий компонент:
 * - Для администраторов: AdminFinances - сводка по компании, отделам и финансам
 * - Для менеджеров (отдел продаж): ManagerFinances - выручка, комиссия, бонусы
 * - Для производственных отделов: ProductionFinances - оплаты за заказы, количество, средний чек
 */
const MyFinances = ({ userPermission }) => {
  useEffect(() => {
    changePageTitle('Мои финансы');
  }, []);

  const companyId = userPermission?.companyId;
  const departmentType = getDepartmentType(companyId);
  
  // Проверка прав доступа к административной сводке
  const hasAdminAccess = Boolean(
    userPermission?.isAdmin ||
      userPermission?.isLocalAdmin ||
      userPermission?.financeAdmin ||
      userPermission?.viewAllFinances  // Новое разрешение для просмотра всех финансов
  );
  
  const isSales = !hasAdminAccess && isSalesDepartment(companyId);

  return (
    <Layout style={{ padding: 15, minHeight: '100vh', background: '#f0f2f5' }}>
      <PageContainer
        title="Мои финансы"
        subTitle={
          hasAdminAccess
            ? 'Сводка по финансам компании и отделам'
            : isSales
            ? 'Ваша выручка и бонусы'
            : 'Финансовый статус заказов вашего отдела'
        }
        extra={[
          <span key="info" style={{ fontSize: 14, color: '#666' }}>
            {/* Можно добавить дополнительную информацию */}
          </span>,
        ]}
      >
        {/* Выбираем компонент в зависимости от прав доступа */}
        {hasAdminAccess ? (
          <AdminFinances userPermission={userPermission} />
        ) : isSales ? (
          <ManagerFinances userPermission={userPermission} />
        ) : (
          <ProductionFinances
            departmentType={departmentType}
            userPermission={userPermission}
          />
        )}
      </PageContainer>
    </Layout>
  );
};

export default MyFinances;

